import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import MainTemplateSegView from "@/views/main/segments/MainTemplateSegView.vue";
import MainVIPSegView from "@/views/main/segments/MainVIPSegView.vue";
import MainWechatMerchantSegView from "@/views/main/segments/MainWechatMerchantSegView.vue";
import MainActivitiesSegView from "@/views/main/segments/MainActivitiesSegView.vue";
import MainDraftSegView from "@/views/main/segments/MainDraftSegView.vue";
import MainFootprintSegView from "@/views/main/segments/MainFootprintSegView.vue";
import {useRoute} from "vue-router";
import {UserAgent} from "@/model/user_agent";



export default /*@__PURE__*/_defineComponent({
  __name: 'MainContentView',
  setup(__props) {


const route = useRoute()
const ua = route.meta.agent as UserAgent

return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createBlock(_component_a_flex, {
    gap: 16,
    justify: "space-between",
    style: {"margin":"16px"}
  }, {
    default: _withCtx(() => [
      _createVNode(MainTemplateSegView, { style: {"margin-bottom":"66px"} }),
      _createVNode(_component_a_flex, {
        vertical: "",
        style: {"width":"420px","flex":"0 0 420px"},
        gap: "middle"
      }, {
        default: _withCtx(() => [
          _createVNode(MainVIPSegView),
          (_unref(ua).wechatMerchant.needShowEnter())
            ? (_openBlock(), _createBlock(MainWechatMerchantSegView, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(MainActivitiesSegView),
          _createVNode(MainDraftSegView),
          _createVNode(MainFootprintSegView)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})